export function initK1Submit() {
	$('body').on('click', 'a[data-submit]', function (event) {
		let $a = $(this)
		event.preventDefault()
		najaGlobal.makeRequest('GET', $a.attr('href')).then((payload) => {
			if (! payload.result) {
				staticNotification.error(payload.errorMessage);
			}
		}).catch((error) => {
			if ('name' in error && error.name === 'HttpError') {
				console.log(error.response);
			}
		});
	})
}